module.exports = __webpack_public_path__ + "img/mortgage.54b6679.svg";